// extracted by mini-css-extract-plugin
module.exports = {"label":"ShareButtons-module--label--1eeXn","button":"ShareButtons-module--button--22Xwo"};